import "./footer.styles.scss";
const Footer = () => {
    return (
        <footer className="footer section">
        <div className="footer-content">
          <small>&copy;Copyright All Rights Reserved</small><br />
          <small> Designed by Abhishek </small>
        </div>
      </footer>
    )
}

export default Footer;